import template from './settings.html';
import controller from './settings.controller';

const menuSettingsComponent = {
  restrict: 'E',
  controller,
  template
};

export default menuSettingsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/settings/settings.component.js
 **/